<template>
  <article
    v-observe-visibility="itemVisibility.getOptions('half')"
    :class="$style.record"
  >
    <a :href="record.url" :class="$style.url">
      <jtn-ui-image
        :class="$style.image"
        :src="recordImage.src"
        :sources="recordImage.sources"
        :loading="recordImage.loading"
        :decoding="recordImage.decoding"
        :hasCommercialLabel="recordImage.hasCommercialLabel"
        :aspectRatio="16 / 9"
        alt=""
      />
      <div
        :class="$style.header"
        v-html="record.header"
      />
    </a>
  </article>
</template>

<script>
import { ObserverVisibility } from '@jtnews/shared';
import { JtnUiImage } from '@jtnews/jtn-ui';

export default {
  name: 'PersonalSelectionItem',
  components: {
    JtnUiImage
  },
  props: {
    record: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      itemVisibility: new ObserverVisibility('half'),
    };
  },
  computed: {
    recordImage() {
      return this.record.image;
    },
  },
  mounted() {
    this.itemVisibility.event.subscribe((state) => {
      if(state.value) {
        this.$emit('visible');
      }
    });
  },
  beforeDestroy() {
    this.itemVisibility.destroy();
  },
}
</script>

<style lang="scss" module>
@import './personal-selection-item.styles';
</style>
